import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import WaveGroup from "../specs/groups/group/WaveGroup";
import { WaveGroupType } from "../specs/groups/group/WaveGroup.types";
import WaveActiveCurationSection from "./curation/WaveActiveCurationSection";
import WaveDisableLinks from "../specs/WaveDisableLinks";
import WaveSlowMode from "../specs/WaveSlowMode";
interface WaveGroupsProps {
  readonly wave: ApiWave;
  readonly useRing?: boolean | undefined;
}
export default function WaveGroups(t0) {
  const $ = _c(24);
  const {
    wave,
    useRing: t1
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const ringClasses = useRing ? "tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-rounded-xl" : "tw-rounded-b-xl lg:tw-rounded-b-none";
  const showChatSettings = wave.chat.enabled;
  const t2 = `tw-relative tw-h-full tw-bg-iron-950 ${ringClasses}`;
  let t3;
  if ($[0] !== wave) {
    t3 = <WaveActiveCurationSection wave={wave} />;
    $[0] = wave;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-x-6 tw-px-4 tw-pt-6"><p className="tw-mb-0 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-300">{"Settings & access"}</p></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== showChatSettings || $[4] !== wave) {
    t5 = showChatSettings && <><WaveSlowMode wave={wave} /><WaveDisableLinks wave={wave} /></>;
    $[3] = showChatSettings;
    $[4] = wave;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] !== wave) {
    t6 = <WaveGroup scope={wave.visibility.scope} type={WaveGroupType.VIEW} wave={wave} />;
    t7 = wave.wave.type !== ApiWaveType.Chat && <><WaveGroup scope={wave.participation.scope} type={WaveGroupType.DROP} wave={wave} /><WaveGroup scope={wave.voting.scope} type={WaveGroupType.VOTE} wave={wave} /></>;
    $[6] = wave;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  let t9;
  if ($[9] !== wave) {
    t8 = <WaveGroup scope={wave.chat.scope} type={WaveGroupType.CHAT} wave={wave} />;
    t9 = <WaveGroup scope={wave.wave.admin_group} type={WaveGroupType.ADMIN} wave={wave} />;
    $[9] = wave;
    $[10] = t8;
    $[11] = t9;
  } else {
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <div className="tw-mt-2 tw-flex tw-flex-col tw-gap-y-0.5 tw-px-2">{t5}{t6}{t7}{t8}{t9}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t3) {
    t11 = <div className="no-scrollbar tw-h-full tw-overflow-y-auto tw-overflow-x-hidden"><div className="tw-pb-4">{t3}{t4}{t10}</div></div>;
    $[18] = t10;
    $[19] = t3;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t2) {
    t12 = <div className="tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800"><div className={t2}>{t11}</div></div>;
    $[21] = t11;
    $[22] = t2;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}